import React from 'react';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router';
import _ from 'underscore';

import Green from '../Images/green-circle.png';
import ManualRed from '../Images/manual-red.png';
import Red from '../Images/red-circle.png';
import MoveRowUpDown from '../MoveRowUpDown/MoveRowUpDown';

export default class ReferencesGridAccordionLib {
  static getChapterName(chapter, rate) {
    return (
      <Link to={`/home/questions/${chapter.reference}/${chapter.id}/${rate}`}>
        {chapter.name}
      </Link>
    );
  }

  static getChaptersForGrid(chapters, references, functions, rate) {
    const orderedChapters = _.sortBy(chapters, 'presentationIndex');
    const formattedChapters = orderedChapters.map((chapter) => {
      const referenceChapters = orderedChapters.filter(
        (chap) => chap.reference === chapter.reference,
      );
      const chapterIndex = referenceChapters.findIndex(
        (i) => i.id === chapter.id,
      );
      return {
        id: chapter.id,
        name: this.getChapterName(chapter, rate),
        description: chapter.description,
        questions: chapter.questionCount,
        pdf: this.pdfColumChapter(chapter, functions.onDeletePdfChapter),
        status: this.statusColumnChapter(
          chapter,
          functions.onStateChapterClick,
        ),
        writer: this.writerColumnChapter(chapter),
        reference: chapter.reference,
        indicatorIndex: chapter.presentationIndex,
        movePresentationIndex: this.getIndicatorIndex(
          chapter,
          referenceChapters[chapterIndex - 1],
          referenceChapters[chapterIndex + 1],
          functions.onMoveChapters,
        ),
        questionsIndicator: this.questionsIndicatorChapter(chapter),
      };
    });

    return formattedChapters;
  }

  static pdfColumChapter(chapter, onDeletePdfChapter) {
    if (chapter.pdfUrl !== '') {
      return (
        <div>
          <a href={chapter.pdfUrl} target="_blank" rel="noreferrer">
            <i className="fa fa-file-pdf-o fa-lg mt-2" />
          </a>
          <i
            onClick={() => {
              onDeletePdfChapter(chapter);
            }}
            className="fa fa-trash fa-lg mt-2"
          />
        </div>
      );
    }
  }

  static statusColumnChapter(chapter, onStateChapterClick) {
    if (chapter.enabled) {
      return (
        <div
          className="statusLabel"
          onClick={() => {
            onStateChapterClick(chapter);
          }}
        >
          Active
        </div>
      );
    }
    return (
      <div
        className="statusLabel"
        onClick={() => {
          onStateChapterClick(chapter);
        }}
      >
        Disabled
      </div>
    );
  }

  static writerColumnChapter(chapter, isFromReference) {
    if (chapter && chapter.primaryWriter) {
      let secondaryChapters = '';
      if (chapter.writers && chapter.writers.length > 0) {
        for (const writer of chapter.writers) {
          secondaryChapters += secondaryChapters !== '' ? '\n' : '';
          secondaryChapters += `${writer.name} ${writer.lastName}`;
        }
      }
      return (
        <div title={secondaryChapters}>
          {`${chapter.primaryWriter.name} ${chapter.primaryWriter.lastName}`}
        </div>
      );
    }
    return '';
  }

  static getIndicatorIndex(current, previous, next, onMoveChapters) {
    return (
      <Col md={6}>
        <MoveRowUpDown
          current={current}
          up={previous}
          down={next}
          onMoveRows={onMoveChapters}
        />
      </Col>
    );
  }

  static questionsIndicatorChapter(chapter) {
    if (chapter.indicators.questions === 'forced') {
      return (
        <img
          className="circleSizeManualRed"
          title={chapter.questionIndicatorReason}
          alt={chapter.questionIndicatorReason}
          src={ManualRed}
          loading="lazy"
        />
      );
    }
    if (chapter.indicators.questions === 'red') {
      return <img alt="red" className="circleSize" src={Red} loading="lazy" />;
    }
    return (
      <img alt="green" className="circleSize" src={Green} loading="lazy" />
    );
  }
}
